module.exports = __webpack_public_path__ + "static/img/huanzheng.f4b72ee.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/huanzheng.png
// module id = ouGh
// module chunks = 1